import { render, staticRenderFns } from "./care-admin-costModification-popup.vue?vue&type=template&id=1b5fa56a"
import script from "./care-admin-costModification-popup.vue?vue&type=script&lang=js"
export * from "./care-admin-costModification-popup.vue?vue&type=script&lang=js"
import style0 from "./care-admin-costModification-popup.vue?vue&type=style&index=0&id=1b5fa56a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports